import React, { useEffect,useCallback } from "react";
import { AnyAction } from "redux";
import { shallowEqual, useDispatch, useSelector } from "react-redux";

import { Components, Types } from "@sendum/core";

import { ShipmentSelectorControlPanel } from "./components/ShipmentSelectorControlPanel";
import { ShipmentSelectorRootState } from "./store/ShipmentSelectorStore";
import * as ShipmentSelectorActions from "./store/ShipmentSelectorActions";

import s from "./ShipmentSelector.module.scss";
import { ShipmentSelectorTable } from "./components/ShipmentSelectorTable";

interface IShipmentSelectorProps {
	onShipmentClick?: (shipmentId: string) => void;
}

export const ShipmentSelector = ({ onShipmentClick }: IShipmentSelectorProps): JSX.Element => {
	const shipmentSelectorRef = React.useRef<HTMLDivElement>(null);
	const timer = React.useRef<ReturnType<typeof setTimeout> | null>(null);

	const dispatch = useDispatch();
	const isLoading = useSelector<ShipmentSelectorRootState, boolean | undefined>((state: ShipmentSelectorRootState) => state.ShipmentSelector.isLoading, shallowEqual);
	const isInitialLoading = useSelector<ShipmentSelectorRootState, boolean | undefined>((state: ShipmentSelectorRootState) => state.ShipmentSelector.isInitialLoading, shallowEqual);
	const error = useSelector<ShipmentSelectorRootState, Error | undefined>((state: ShipmentSelectorRootState) => state.ShipmentSelector.error, shallowEqual);
	const shipments = useSelector<ShipmentSelectorRootState, Types.TSmallShipment[] | undefined>((state: ShipmentSelectorRootState) => state.ShipmentSelector.shipments, shallowEqual);
	const total = useSelector<ShipmentSelectorRootState, number | undefined>((state: ShipmentSelectorRootState) => state.ShipmentSelector.total, shallowEqual);

	const planLoading = useCallback((): void => {
		if (timer.current !== null) {
			clearTimeout(timer.current);
			timer.current = null;
		}

		if (!isLoading) {
			timer.current = setTimeout(() => {
				dispatch(ShipmentSelectorActions.loadShipments(true) as unknown as AnyAction);
				timer.current = null;
			}, 300);
		}
	},[dispatch, isLoading]);

	useEffect(() => {
		setTimeout(() => {
			dispatch(ShipmentSelectorActions.loadShipments() as unknown as AnyAction);
		}, 200);

		return () => {
			dispatch(ShipmentSelectorActions.resetState());
		};
	}, [dispatch]);

	return (
		<div className={s.shipmentSelector} ref={shipmentSelectorRef}>
			{isInitialLoading && (<Components.Loader text="Loading" className={s.loading} />)}
			<Components.ErrorComponent error={error}/>

			{!isInitialLoading && !error && (
				<div className={s.shipmentSelector__column}>
					<div className={s.shipmentSelector__controlPanel}>
						<ShipmentSelectorControlPanel onChange={planLoading}/>
					</div>
					<div className={s.shipmentSelector__content}>
						<ShipmentSelectorTable shipments={shipments} total={total} isLoading={isLoading} onShipmentClick={onShipmentClick} onChange={planLoading}/>
					</div>
				</div>)}
		</div>
	);
};
